import React from "react";
import { Badge } from "../../../components/ui/badge";
import { MockProvider, ConnectionStatus, categoryLabels } from "../mock-providers";
import { ProviderLogo } from "./provider-logo";
import { ConnectButton } from "./connect-button";

interface ProviderCardProps {
    provider: MockProvider;
    status: ConnectionStatus;
    onConnect: () => void;
    onDisconnect: () => void;
}

export function ProviderCard({ provider, status, onConnect, onDisconnect }: ProviderCardProps) {
    return (
        <div className="flex flex-col gap-3 rounded-lg border bg-card p-4">
            <div className="flex items-start justify-between">
                <div className="flex items-start gap-3">
                    <ProviderLogo
                        brandColor={provider.brandColor}
                        icon={provider.icon}
                        logoBgColor={provider.logoBgColor}
                    />
                    <div className="flex flex-col">
                        <span className="font-semibold">{provider.name}</span>
                        <span className="text-sm text-muted-foreground">{provider.description}</span>
                    </div>
                </div>
            </div>
            <div className="flex items-center justify-between">
                <Badge variant="secondary">{categoryLabels[provider.category]}</Badge>
                <ConnectButton status={status} onConnect={onConnect} onDisconnect={onDisconnect} />
            </div>
        </div>
    );
}
